<template> 
  <stats-card data-background-color="green" :key="componentKey">
    <template slot="header">
      <strong>{{title}}</strong>
    </template>

    <template slot="content">
      <mdb-line-chart
        :data="lineChartData"
        :options="lineChartOptions"
        :width="2000"
        :height="300"
      ></mdb-line-chart>
    </template>

    <template slot="footer">
      <div class="stats">
        <md-icon>date_range</md-icon>
        Last updated at: {{updated_at}}
      </div>
    </template>
  </stats-card>

</template>

<script>
  import { mdbLineChart, mdbContainer } from "mdbvue";
  import { StatsCard } from "@/components";

  export default {
    name: 'LineChart',
    props: ['title', 'updated_at', 'peopleOnlineDataSet', 'labels'],
    components: {
      StatsCard,
      mdbLineChart,
      mdbContainer
    },
    data() {
      return {
        componentKey: 0,
        lineChartData: {
          labels: this.labels,
          datasets: this.peopleOnlineDataSet
        },
        lineChartOptions: {
          responsive: false,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                }
              }
            ]
          }
        }
      };
    },
    watch: {
      updated_at: function() {
        this.lineChartData.labels = this.labels;
        this.lineChartData.datasets = this.peopleOnlineDataSet;
        this.componentKey += 1;
      }
    }
  };
</script>
